import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import BookKeepingListPage from 'src/components/views/BookKeeping/BookKeepingListPage';

const mapStateToProps = ({ userState: { isAgent, isDomestic, userInfo } }: IStoreState) => ({
  isAgent,
  isDomestic,
  userInfo,
});

export default connect(mapStateToProps)(BookKeepingListPage);


// WEBPACK FOOTER //
// ./src/containers/BookKeepingList.ts